var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 18,
    viewBox: "0 0 50 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4348 5.18639C41.9941 4.82028 40.8754 2.49145 40.6212 1.3728C40.1331 3.69146 37.8754 4.8813 36.8076 5.18639C39.0042 5.67453 40.2653 8.03387 40.6212 9.15252C40.8653 7.07793 43.2653 5.64402 44.4348 5.18639Z",
    fill: "url(#paint0_linear_3042_46782)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0109 2.24329C47.5465 2.02793 46.8753 0.658031 46.7227 0C46.4298 1.36392 45.0753 2.06382 44.4346 2.24329C45.7525 2.53043 46.5092 3.91827 46.7227 4.5763C46.8692 3.35596 48.3092 2.51248 49.0109 2.24329Z",
    fill: "#FF322B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4007 10.4864C47.1315 10.2998 46.5498 9.11253 46.4176 8.54224C46.1638 9.7243 44.9898 10.3309 44.4346 10.4864C45.5768 10.7353 46.2325 11.9381 46.4176 12.5084C46.5446 11.4507 47.7926 10.7197 48.4007 10.4864Z",
    fill: "#FF322B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27539 18V13.8813L7.24152 15.1017L3.27539 18Z",
    fill: "#FF180A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.60316C0 4.878 3.01984 1.85815 6.74501 1.85815H28.1703C31.8955 1.85815 34.9153 4.878 34.9153 8.60316C34.9153 12.3283 31.8955 15.3482 28.1703 15.3482H6.74501C3.01985 15.3482 0 12.3283 0 8.60316Z",
    fill: "url(#paint1_linear_3042_46782)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61477 13V4.27273H8.45994V7.87358H12.2057V4.27273H14.0466V13H12.2057V9.39489H8.45994V13H6.61477ZM23.5878 8.63636C23.5878 9.58807 23.4074 10.3977 23.0466 11.0653C22.6886 11.733 22.2 12.2429 21.5807 12.5952C20.9642 12.9446 20.271 13.1193 19.5011 13.1193C18.7256 13.1193 18.0295 12.9432 17.4131 12.5909C16.7966 12.2386 16.3094 11.7287 15.9514 11.0611C15.5935 10.3935 15.4145 9.58523 15.4145 8.63636C15.4145 7.68466 15.5935 6.875 15.9514 6.20739C16.3094 5.53977 16.7966 5.03125 17.4131 4.68182C18.0295 4.32955 18.7256 4.15341 19.5011 4.15341C20.271 4.15341 20.9642 4.32955 21.5807 4.68182C22.2 5.03125 22.6886 5.53977 23.0466 6.20739C23.4074 6.875 23.5878 7.68466 23.5878 8.63636ZM21.717 8.63636C21.717 8.01989 21.6247 7.5 21.4401 7.0767C21.2582 6.65341 21.0011 6.33239 20.6688 6.11364C20.3364 5.89489 19.9472 5.78551 19.5011 5.78551C19.0551 5.78551 18.6659 5.89489 18.3335 6.11364C18.0011 6.33239 17.7426 6.65341 17.558 7.0767C17.3761 7.5 17.2852 8.01989 17.2852 8.63636C17.2852 9.25284 17.3761 9.77273 17.558 10.196C17.7426 10.6193 18.0011 10.9403 18.3335 11.1591C18.6659 11.3778 19.0551 11.4872 19.5011 11.4872C19.9472 11.4872 20.3364 11.3778 20.6688 11.1591C21.0011 10.9403 21.2582 10.6193 21.4401 10.196C21.6247 9.77273 21.717 9.25284 21.717 8.63636ZM24.2238 5.79403V4.27273H31.3914V5.79403H28.7195V13H26.8957V5.79403H24.2238Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3042_46782",
    x1: 36.8076,
    y1: 5.26266,
    x2: 44.4348,
    y2: 5.26266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCF58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3042_46782",
    x1: 0,
    y1: 8.60316,
    x2: 34.9153,
    y2: 8.60316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCF58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.2d98aa4d0c79519e47eeaa151c215caa.svg";
export { ForwardRef as ReactComponent };